// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3gKdV","errors":"Errors_errors__1qGGT"};